import React, { useState } from "react";
import Backend from "../../../Components/Backend/Backend";
import toast from "react-hot-toast";
import "./Status.css";
const backend = await new Backend().init();

export default function Status(props) {
  const { id, type, broker, name, reload, load, userType } = props;

  const [status, setStatus] = useState(props.status);
  const [loading, setLoading] = useState(false);

  const updateStatus = () => {
    if (userType === 5 || userType === 6)
      return toast.error("Permission Not Allowed.");

    if (loading) return; // prevent multiple clicks

    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      status: status === 0 ? 1 : 0,
      type: type,
      status_id: id,
    };

    backend.update_status(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        if (reload === 1) {
          load();
        } else {
          loadStatus();
        }
      } else {
        toast.error(r.message);
      }
    });
  };

  const loadStatus = () => {
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      type: type,
      status_id: id,
    };

    backend.load_status(data).then((r) => {
      if (r.error === "False") {
        if (type === "TRADE") {
          setStatus(r.status.trade);
        } else if (type === "ONLY_SQ") {
          setStatus(r.status.only_sq);
        } else if (type === "STATUS") {
          setStatus(r.status.status);
        }
      } else {
        toast.error(r.message);
      }
    });
  };

  const buttonText = name ?? (status === 1 ? "Active" : "Deactive");

  const activeStatusColor =
    status === 0 ? "bg-[var(--sell)]" : "bg-[var(--buy)]";

  return (
    <div key={status}>
      <button
        onClick={broker === 1 ? null : updateStatus}
        disabled={loading}
        className={`${activeStatusColor} relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
      >
        {buttonText}
      </button>
    </div>
  );
}
